import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
var VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations'];
var store = {};
void function updateModules() {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js'); // If store is an exported method = classic mode (deprecated)
  // Enforce store modules

  store.modules = store.modules || {};
  resolveStoreModules(require('../store/actions.js'), 'actions.js');
  resolveStoreModules(require('../store/plugin.js'), 'plugin.js');
  resolveStoreModules(require('../store/mutations.js'), 'mutations.js');
  resolveStoreModules(require('../store/getters.js'), 'getters.js');
  resolveStoreModules(require('../store/utils/api.js'), 'utils/api.js');
  resolveStoreModules(require('../store/utils/logger.js'), 'utils/logger.js');
  resolveStoreModules(require('../store/modules/pageActions/index.js'), 'modules/pageActions/index.js');
  resolveStoreModules(require('../store/modules/i18n/index.js'), 'modules/i18n/index.js');
  resolveStoreModules(require('../store/modules/layer/index.js'), 'modules/layer/index.js');
  resolveStoreModules(require('../store/modules/lookbook/index.js'), 'modules/lookbook/index.js');
  resolveStoreModules(require('../store/modules/configurator/index.js'), 'modules/configurator/index.js');
  resolveStoreModules(require('../store/modules/request/index.js'), 'modules/request/index.js');
  resolveStoreModules(require('../store/modules/search/index.js'), 'modules/search/index.js');
  resolveStoreModules(require('../store/modules/sharedEnv/index.js'), 'modules/sharedEnv/index.js');
  resolveStoreModules(require('../store/modules/user/index.js'), 'modules/user/index.js');
  resolveStoreModules(require('../store/modules/wishlist/index.js'), 'modules/wishlist/index.js');
  resolveStoreModules(require('../store/modules/category/index.js'), 'modules/category/index.js');
  resolveStoreModules(require('../store/modules/cart/index.js'), 'modules/cart/index.js');
  resolveStoreModules(require('../store/modules/product/index.js'), 'modules/product/index.js');
  resolveStoreModules(require('../store/modules/cart/types.js'), 'modules/cart/types.js');
  resolveStoreModules(require('../store/modules/i18n/mutations.js'), 'modules/i18n/mutations.js');
  resolveStoreModules(require('../store/modules/i18n/types.js'), 'modules/i18n/types.js');
  resolveStoreModules(require('../store/modules/layer/actions.js'), 'modules/layer/actions.js');
  resolveStoreModules(require('../store/modules/layer/getters.js'), 'modules/layer/getters.js');
  resolveStoreModules(require('../store/modules/category/mutations.js'), 'modules/category/mutations.js');
  resolveStoreModules(require('../store/modules/layer/mutations.js'), 'modules/layer/mutations.js');
  resolveStoreModules(require('../store/modules/layer/types.js'), 'modules/layer/types.js');
  resolveStoreModules(require('../store/modules/lookbook/actions.js'), 'modules/lookbook/actions.js');
  resolveStoreModules(require('../store/modules/lookbook/getters.js'), 'modules/lookbook/getters.js');
  resolveStoreModules(require('../store/modules/category/types.js'), 'modules/category/types.js');
  resolveStoreModules(require('../store/modules/lookbook/mutations.js'), 'modules/lookbook/mutations.js');
  resolveStoreModules(require('../store/modules/lookbook/types.js'), 'modules/lookbook/types.js');
  resolveStoreModules(require('../store/modules/pageActions/actions.js'), 'modules/pageActions/actions.js');
  resolveStoreModules(require('../store/modules/pageActions/getters.js'), 'modules/pageActions/getters.js');
  resolveStoreModules(require('../store/modules/cart/mutations.js'), 'modules/cart/mutations.js');
  resolveStoreModules(require('../store/modules/pageActions/mutations.js'), 'modules/pageActions/mutations.js');
  resolveStoreModules(require('../store/modules/pageActions/types.js'), 'modules/pageActions/types.js');
  resolveStoreModules(require('../store/modules/product/actions.js'), 'modules/product/actions.js');
  resolveStoreModules(require('../store/modules/category/actions.js'), 'modules/category/actions.js');
  resolveStoreModules(require('../store/modules/configurator/actions.js'), 'modules/configurator/actions.js');
  resolveStoreModules(require('../store/modules/product/mutations.js'), 'modules/product/mutations.js');
  resolveStoreModules(require('../store/modules/product/types.js'), 'modules/product/types.js');
  resolveStoreModules(require('../store/modules/request/actions.js'), 'modules/request/actions.js');
  resolveStoreModules(require('../store/modules/request/getters.js'), 'modules/request/getters.js');
  resolveStoreModules(require('../store/modules/configurator/getters.js'), 'modules/configurator/getters.js');
  resolveStoreModules(require('../store/modules/request/mutations.js'), 'modules/request/mutations.js');
  resolveStoreModules(require('../store/modules/request/types.js'), 'modules/request/types.js');
  resolveStoreModules(require('../store/modules/search/actions.js'), 'modules/search/actions.js');
  resolveStoreModules(require('../store/modules/search/getters.js'), 'modules/search/getters.js');
  resolveStoreModules(require('../store/modules/category/getters.js'), 'modules/category/getters.js');
  resolveStoreModules(require('../store/modules/search/mutations.js'), 'modules/search/mutations.js');
  resolveStoreModules(require('../store/modules/search/types.js'), 'modules/search/types.js');
  resolveStoreModules(require('../store/modules/sharedEnv/getters.js'), 'modules/sharedEnv/getters.js');
  resolveStoreModules(require('../store/modules/configurator/mutations.js'), 'modules/configurator/mutations.js');
  resolveStoreModules(require('../store/modules/sharedEnv/mutations.js'), 'modules/sharedEnv/mutations.js');
  resolveStoreModules(require('../store/modules/sharedEnv/types.js'), 'modules/sharedEnv/types.js');
  resolveStoreModules(require('../store/modules/user/actions.js'), 'modules/user/actions.js');
  resolveStoreModules(require('../store/modules/user/getters.js'), 'modules/user/getters.js');
  resolveStoreModules(require('../store/modules/configurator/types.js'), 'modules/configurator/types.js');
  resolveStoreModules(require('../store/modules/user/mutations.js'), 'modules/user/mutations.js');
  resolveStoreModules(require('../store/modules/user/types.js'), 'modules/user/types.js');
  resolveStoreModules(require('../store/modules/wishlist/actions.js'), 'modules/wishlist/actions.js');
  resolveStoreModules(require('../store/modules/wishlist/getters.js'), 'modules/wishlist/getters.js');
  resolveStoreModules(require('../store/modules/i18n/actions.js'), 'modules/i18n/actions.js');
  resolveStoreModules(require('../store/modules/wishlist/mutations.js'), 'modules/wishlist/mutations.js');
  resolveStoreModules(require('../store/modules/wishlist/types.js'), 'modules/wishlist/types.js');
  resolveStoreModules(require('../store/modules/i18n/getters.js'), 'modules/i18n/getters.js');
  resolveStoreModules(require('../store/modules/cart/getters.js'), 'modules/cart/getters.js');
  resolveStoreModules(require('../store/modules/cart/actions.js'), 'modules/cart/actions.js');
  resolveStoreModules(require('../store/modules/product/getters.js'), 'modules/product/getters.js'); // If the environment supports hot reloading...
}(); // createStore

export var createStore = store instanceof Function ? store : function () {
  return new Vuex.Store(Object.assign({
    strict: process.env.NODE_ENV !== 'production'
  }, store));
};

function resolveStoreModules(moduleData, filename) {
  moduleData = moduleData.default || moduleData; // Remove store src + extension (./foo/index.js -> foo/index)

  var namespace = filename.replace(/\.(js|mjs|ts)$/, '');
  var namespaces = namespace.split('/');
  var moduleName = namespaces[namespaces.length - 1];
  var filePath = "store/".concat(filename);
  moduleData = moduleName === 'state' ? normalizeState(moduleData, filePath) : normalizeModule(moduleData, filePath); // If src is a known Vuex property

  if (VUEX_PROPERTIES.includes(moduleName)) {
    var property = moduleName;

    var _storeModule = getStoreModule(store, namespaces, {
      isProperty: true
    }); // Replace state since it's a function


    mergeProperty(_storeModule, moduleData, property);
    return;
  } // If file is foo/index.js, it should be saved as foo


  var isIndexModule = moduleName === 'index';

  if (isIndexModule) {
    namespaces.pop();
    moduleName = namespaces[namespaces.length - 1];
  }

  var storeModule = getStoreModule(store, namespaces);

  for (var _i = 0, _VUEX_PROPERTIES = VUEX_PROPERTIES; _i < _VUEX_PROPERTIES.length; _i++) {
    var _property = _VUEX_PROPERTIES[_i];
    mergeProperty(storeModule, moduleData[_property], _property);
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced;
  }
}

function normalizeRoot(moduleData, filePath) {
  moduleData = moduleData.default || moduleData;

  if (moduleData.commit) {
    throw new Error("[nuxt] ".concat(filePath, " should export a method that returns a Vuex instance."));
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData);
  }

  return normalizeModule(moduleData, filePath);
}

function normalizeState(moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn("".concat(filePath, " should export a method that returns an object"));
    var state = Object.assign({}, moduleData);
    return function () {
      return state;
    };
  }

  return normalizeModule(moduleData, filePath);
}

function normalizeModule(moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn("'state' should be a method that returns an object in ".concat(filePath));

    var _state = Object.assign({}, moduleData.state); // Avoid TypeError: setting a property that has only a getter when overwriting top level keys


    moduleData = Object.assign({}, moduleData, {
      state: function state() {
        return _state;
      }
    });
  }

  return moduleData;
}

function getStoreModule(storeModule, namespaces) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$isProperty = _ref.isProperty,
      isProperty = _ref$isProperty === void 0 ? false : _ref$isProperty;

  // If ./mutations.js
  if (!namespaces.length || isProperty && namespaces.length === 1) {
    return storeModule;
  }

  var namespace = namespaces.shift();
  storeModule.modules[namespace] = storeModule.modules[namespace] || {};
  storeModule.modules[namespace].namespaced = true;
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {};
  return getStoreModule(storeModule.modules[namespace], namespaces, {
    isProperty: isProperty
  });
}

function mergeProperty(storeModule, moduleData, property) {
  if (!moduleData) return;

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state;
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData);
  }
}